import CalendarSVG from "/public/icons/calendar.svg";
import TimeSVG from "/public/icons/time.svg";

import { getTranslation } from "@/i18n/get-translation";
import { IDoctorInfo, IReason } from "@/types/agenda.type";
import MOMENTJS_DATE_FORMATES from "@/common/constants/momentjs-format";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  FaLocationDot,
  FaCalendarDay,
  FaClock,
  FaGlobe,
  FaBuilding,
} from "react-icons/fa6";
import GoogleMap from "@components/google-map/google-map";
import { scrollToElement } from "@/utils/utils";

interface IDoctorAppointmentCard {
  locale: string;
  selectedDateTime?: string;
  setAppStep: any;
  doctorInfo?: IDoctorInfo;
  selectedReason?: IReason;
  appStep: number;
}

export default function DoctorAppointmentCard({
  locale,
  selectedDateTime,
  setAppStep,
  doctorInfo,
  selectedReason,
  appStep,
}: IDoctorAppointmentCard) {
  const t = getTranslation(locale, "appointment");
  const [profileImage, setProfileImage] = useState<string>("");

  const doctorAddress: string[] | undefined = doctorInfo?.address?.split(";");
  const doctorDesignation: string[] | undefined =
    doctorInfo?.speciality?.split(";");

  useEffect(() => {
    if (doctorInfo?.media?.url) {
      setProfileImage(doctorInfo?.media?.url);
    } else {
      const placeholderImage =
        doctorInfo?.gender === "male"
          ? "/images/doctor-male-avatar.webp"
          : "/images/doctor-female-avatar.webp";
      setProfileImage(placeholderImage);
    }
  }, [doctorInfo]);

  return (
    <div className="sticky top-28 max-md:top-20">
      <div>
        {doctorInfo?.custom_clinic_name && (
          <div className="text-agenda-purple-800 flex not-italic font-light mt-6">
            <div className="mr-3 text-agenda-blue-600 mt-1 flex-[0_0_1rem]">
              <FaBuilding />
            </div>
            <div>
              <div className="font-bold mb-[0.125rem]">{t("clinic")}</div>
              <div className="">{doctorInfo.custom_clinic_name}</div>
            </div>
          </div>
        )}

        {doctorAddress && (
          <address className="text-agenda-purple-800 flex not-italic mt-6">
            <div className="mr-3 mt-[0.125rem] text-agenda-blue-600 flex-[0_0_1rem]">
              <FaLocationDot />
            </div>
            <div>
              <div className="font-bold mb-[0.125rem]">{t("location")}</div>
              <div className="">
                {doctorAddress &&
                  doctorAddress.map((addressItem: string, index: number) => {
                    return <div key={`address_${index}`}>{addressItem}</div>;
                  })}
                <div>
                  {doctorInfo?.zip_code && (
                    <span>{doctorInfo?.zip_code}&nbsp;</span>
                  )}
                  {doctorInfo?.city && <span>{doctorInfo?.city}</span>}
                  {doctorInfo?.nationality && (
                    <span>,&nbsp;{doctorInfo?.nationality}</span>
                  )}
                </div>
                <button
                  onClick={()=>{scrollToElement('see_map')}}
                  className="text-agenda-blue-600 underline border-none appearance-none shadow-none"
                >
                  {t("see_map")}
                </button>
              </div>
            </div>
          </address>
        )}

        {doctorInfo?.website && (
          <div className="text-agenda-purple-800 flex not-italic font-light mt-6">
            <div className="mr-3 text-agenda-blue-600 mt-1 flex-[0_0_1rem]">
              <FaGlobe />
            </div>
            <div>
              <div className="font-bold mb-[0.125rem]">{t("website")}</div>
              <div className="">{doctorInfo?.website}</div>
            </div>
          </div>
        )}

        <div className="text-agenda-purple-800 flex not-italic mt-6">
          <div className="mr-3 text-agenda-blue-600 mt-1 flex-[0_0_1rem]">
            <FaCalendarDay />
          </div>
          <div>
            <div className="font-bold mb-[0.125rem]">{t("date")}</div>
            <div className="">
              {selectedDateTime ? (
                dayjs(selectedDateTime).format(MOMENTJS_DATE_FORMATES.cardDate)
              ) : (
                <div className="text-agenda-blue-200">________</div>
              )}
            </div>
          </div>
        </div>
        <div className="text-agenda-purple-800 flex not-italic font-light  mt-6">
          <div className="mr-3 text-agenda-blue-600 mt-1 flex-[0_0_1rem]">
            <FaClock />
          </div>
          <div>
            <div className="font-bold mb-[0.125rem]">{t("time")}</div>
            <div className="">
              {selectedDateTime ? (
                dayjs(selectedDateTime).format(MOMENTJS_DATE_FORMATES.ampmtime)
              ) : (
                <div className="text-agenda-blue-200">________</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mt-10 border border-agenda-grey-200 rounded-2xl overflow-hidden">
        {doctorAddress && (
          <GoogleMap address={doctorAddress.join(", ")} />
        )}
      </div>
    </div>
  );
}
